import { BasePlugin } from '../base'
import mdcButton from './mdc-button.vue'
import mdcButtonBase from './mdc-button-base.vue'

export { mdcButtonBase, mdcButton }

export default BasePlugin({
  mdcButton
})
